<template>
  <div class="loan-container">
    <div class="content">
      <template v-if="isDefaultPlatform">
        <template v-if="isEarlyPaymentEnabled">
          <!-- <v-slide-y-transition>
            <CompareLoansCard v-if="ready" />
          </v-slide-y-transition> -->
          <v-slide-y-transition>
            <WooriCrowdCard v-if="ready" />
          </v-slide-y-transition>
          <v-slide-y-transition>
            <PullRevenueCard v-if="ready" />
          </v-slide-y-transition>
        </template>
        <template v-else>
          <!-- <v-slide-y-transition>
            <CompareLoansCard v-if="ready" />
          </v-slide-y-transition> -->
          <v-slide-y-transition>
            <WooriCrowdCard v-if="ready" />
          </v-slide-y-transition>
          <v-slide-y-transition>
            <PullRevenueCard v-if="ready" />
          </v-slide-y-transition>
        </template>
      </template>
      <template v-else>
        <!-- <v-slide-y-transition>
          <CompareLoansCard v-if="ready" />
        </v-slide-y-transition> -->
        <v-slide-y-transition>
          <WooriCrowdCard v-if="ready" />
        </v-slide-y-transition>
        <v-slide-y-transition v-if="!isBuynowWooriCrowd">
          <PullRevenueCard v-if="ready" />
        </v-slide-y-transition>
      </template>
    </div>
  </div>
</template>

<script>
import { sleep } from '@/util'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  components: {
    // EarlypayCard: () => import('@/components/main/cards/earlypay/EarlypayCard.vue'),
    PullRevenueCard: () => import('@/components/main/cards/pull-revenue/PullRevenueCard.vue'),
    WooriCrowdCard: () => import('@/components/main/cards/woori-crowd/WooriCrowdCard.vue'),
    // CompareLoansCard: () => import('@/components/main/cards/compare-loans/CompareLoansCard.vue'),
  },
  data() {
    return {
      ready: false,
    }
  },
  async mounted() {
    await sleep(700)
    this.ready = true
  },
  computed: {
    ...mapState('contract', {
      contractCurrent: 'current',
    }),
    ...mapGetters('myfinbiz', ['isDefaultPlatform', 'platformCode', 'organization']),
    isEarlyPaymentEnabled() {
      // 임시적으로 update로 이동시키는 코드
      return (
        this.contractCurrent?.status === 'started' &&
        this.contractCurrent.isEarlyPaymentEnabled === true
      )
    },
    isBuynowWooriCrowd() {
      return this.platformCode === 'buynow-woori-crowd'
    },
  },
  created() {
    _meta({
      titles: ['메인'],
    })
    this.refresh()
  },
  watch: {
    contractCurrent: {
      deep: true,
      immediate: true,
      async handler(v) {
        console.log('MAIN PAGE!!!!', v)

        if (!v) {
          return
        }
        // if (['started'].includes(v.status) === false) {
        //   // return this.refresh()
        // }


        if (v.isEarlyPaymentEnabled) {
          await this.$router.replace('/earlypay')
        } 
        else {
          if (this.organization?.serviceSetting?.providesInfo) {
            await this.$router.replace('/sales')
          }
          
        }
      },
    },
  },
  methods: {
    ...mapMutations('status', ['refresh']),
  },
}
</script>

<style lang="scss" scoped></style>
